module.exports = __webpack_public_path__ + "static/media/covid_gif.3a6926ff.gif";